//
export default [
    {
        text: '#',
        value: 'id',
        width: '5%',
    },
    {
        text: 'bodega',
        value: 'wh_warehouse_name',
    },
    {
        text: 'creado por',
        value: 'g_user_warehouseman_name',
    },
    {
        text: 'descripción',
        value: 'description',
        width: '15%',
    },
    {
        text: 'n° items',
        value: 'item_number',
        align: 'center',
        format: 'number',
    },
    // {
    //     text: "confirmado por",
    //     value: "g_user_supervisor_name",
    // },
    {
        text: 'estado',
        value: 'g_state_state',
        align: 'center',
        component: {
            type: 'chip-label',
            props: {
                palette: {
                    pendiente: 'accent lighten-3',
                    realizado: 'secondary lighten-3',
                    confirmado: 'success lighten-3',
                    rechazado: 'error lighten-3',
                },
                noEvents: true,
                small: true,
            },
        },
    },
    {
        text: 'confirmación',
        value: 'inventory_date',
        sortable: true,
        align: 'right',
        format: 'date',
    },
    {
        text: 'modificacion',
        value: 'updated_at',
        sortable: true,
        align: 'right',
        format: 'datetime',
    },
]
